import mainCaller from './mainCaller';

// 지점 기타 일정 API — 지점 스케줄의 '기타' 유형(정수기 점검, 임직원 외출 등)
// 목록은 지점 스케줄 조회(getAllLessonsByType)가 다른 일정과 함께 내려주므로 여기에 없다.

// POST /admin/api/v1/branch-schedules
export const createBranchSchedule = async (data, token) => {
  return await mainCaller(`admin/api/v1/branch-schedules`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

// GET /admin/api/v1/branch-schedules/{branchScheduleId}
export const getBranchScheduleById = async (branchScheduleId, token) => {
  return await mainCaller(`admin/api/v1/branch-schedules/${branchScheduleId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// PUT /admin/api/v1/branch-schedules/{branchScheduleId}
export const updateBranchSchedule = async (branchScheduleId, data, token) => {
  return await mainCaller(`admin/api/v1/branch-schedules/${branchScheduleId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
};

// DELETE /admin/api/v1/branch-schedules/{branchScheduleId}
export const deleteBranchSchedule = async (branchScheduleId, token) => {
  return await mainCaller(`admin/api/v1/branch-schedules/${branchScheduleId}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};
